module.exports = __webpack_public_path__ + "img/eazigear_full_logo.22ae393c.png";